import React, { useContext } from 'react';
import get from 'lodash/get';

import Control from './Control';
import { ControlGroupSpec } from 'src/models/Sidekick/SidekickModuleSpec';
import { H3 } from '@ad-scripts/presentation/components/common/headers';
import { ActionsSpecs } from 'src/presentation/components/pages/sidekick/threads/SidekickActionsConstants';
import { ThreadModuleContext } from './ThreadModuleContext';

type ControlGroupProps = {
  controlGroup: ControlGroupSpec;
  specAttr: string;
};

export default function ControlGroup({ specAttr, controlGroup }: ControlGroupProps) {
  const { isModifier, module, modifier } = useContext(ThreadModuleContext);
  const modifierOrModule = isModifier ? modifier : module;

  const spec = get(ActionsSpecs[modifierOrModule!.name], specAttr);
  const name = spec?.name || controlGroup?.name;

  return (
    <>
      {controlGroup.name ? <H3>{name}</H3> : null}
      {controlGroup.controls.map((controlSpec, idx) => (
        <Control specAttr={`${specAttr}.controls.${idx}`} key={idx} controlSpec={controlSpec} /> // TODO: fix key
      ))}
    </>
  );
}
